import {
  FETCH_RAS_INFO,
  RECEIVE_RAS_INFO,
} from '../actions/actionTypes'

const initialState = [];

const rasInfo = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RAS_INFO:
      return state;
    case RECEIVE_RAS_INFO:
      return [].concat(action.value);
    default:
      return state;
  }
}

export default rasInfo;